import { PopperTooltip } from "@unified-checkout/design-system";
import { CircleInfo } from "@unified-checkout/design-system/icons/index";
import { useLangStore } from "@app/dashboard/store/lang";
import styles from "./title.module.scss";

export const Title = ({
  label,
  hint
}: {
  label: string,
  hint?: string
}) => {
  const { lang } = useLangStore();

  return (
    <div className={styles["section-title"]}>
      <h3>{label}</h3>
      {
        hint &&
        <PopperTooltip
          text={hint}
          placement={lang === 'en' ? "right" : "left"}
        >
          {CircleInfo}
        </PopperTooltip>
      }
    </div>
  )
}
